export default function () {
  return {
    check: {
      compactVersion: '',
      fullVersion: '',
      maintenanceMode: 'no',
      // yes, no, in-progress
      status: ''
    }
  };
}